/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { LinkEditContext } from "cms/links/link-selector/context/edit";

const SelectedWebpageLink = () => {
    
    const { selectedLink } = useContext(LinkEditContext);
    
    return (
        <Fragment>
            <div style={{
                background: "#F3F8F9", borderRadius: "8px", padding: "16px",
                fontSize: "11px"
            }}
            >
                <div className='link-edit-selected-label'>
                    Selected Webpage
                </div>
                <div className='link-edit-selected-text'>
                    {selectedLink?.text}
                </div>
            </div>
        </Fragment>
    );
};

export { SelectedWebpageLink };
